<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div
          class="ts-border-solid ts-border-gray-300 ts-border ts-rounded ts-rounded-t-none ts-border-t-0 ts-p-3"
        >
          <form class="form-horizontal">
            <div class="row">
              <div class="col-md-6">
                <div class="row m-b-15">
                  <label class="col-form-label col-md-4 required">{{
                    $t('gameSetting.gameType')
                  }}</label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model.number="model.game_type_id"
                      :disabled="isEdit"
                    >
                      <option
                        v-for="(type, index) in game_type_options"
                        :key="index"
                        :value="type.value"
                        >{{ type.label }}</option
                      >
                    </select>
                    <div class="validate" v-if="errors.has('game_type_id')">
                      {{ errors.first('game_type_id') }}
                    </div>
                  </div>
                </div>
                <div class="row m-b-15">
                  <label class="col-form-label col-md-4 required">{{
                    $t('gameSetting.settingName')
                  }}</label>
                  <div class="col-md-7">
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="model.game_setting"
                    />
                    <div class="validate" v-if="errors.has('game_setting')">
                      {{ errors.first('game_setting') }}
                    </div>
                  </div>
                </div>
                <div class="row m-b-15">
                  <label class="col-form-label col-md-4 required">{{
                    $t('gameSetting.numberDayPayout')
                  }}</label>
                  <div class="col-md-7">
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="model.num_day_allow_payout"
                    />
                    <div
                      class="validate"
                      v-if="errors.has('num_day_allow_payout')"
                    >
                      {{ errors.first('num_day_allow_payout') }}
                    </div>
                  </div>
                </div>
                <div class="row m-b-15">
                  <label class="col-form-label col-md-4 required">{{
                    $t('gameSetting.beforeClose')
                  }}</label>
                  <div class="col-md-7">
                    <div class="input-group">
                      <input
                        v-model.number="model.minute_close_before_result"
                        type="number"
                        class="form-control"
                        aria-describedby="basic-addon2"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">{{
                          $t('gameSetting.minute')
                        }}</span>
                      </div>
                    </div>
                    <div
                      class="validate"
                      v-if="errors.has('minute_close_before_result')"
                    >
                      {{ errors.first('minute_close_before_result') }}
                    </div>
                  </div>
                </div>
                <div class="row m-b-15">
                  <label class="col-form-label col-md-4 required">{{
                    $t('gameSetting.cancelBetting')
                  }}</label>
                  <div class="col-md-7">
                    <div class="input-group">
                      <input
                        v-model.number="model.minute_allow_cancel_betting"
                        type="number"
                        class="form-control"
                        aria-describedby="basic-addon2"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">{{
                          $t('gameSetting.minute')
                        }}</span>
                      </div>
                    </div>
                    <div
                      class="validate"
                      v-if="errors.has('minute_allow_cancel_betting')"
                    >
                      {{ errors.first('minute_allow_cancel_betting') }}
                    </div>
                  </div>
                </div>
                <div class="row m-b-15">
                  <label class="col-form-label col-md-4"></label>
                  <div class="col-md-7">
                    <ts-checkbox v-model="model.inactive">{{
                      $t('gameSetting.inactive')
                    }}</ts-checkbox>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row m-b-15">
                  <label class="col-form-label col-md-4">{{
                    $t('gameSetting.logo')
                  }}</label>
                  <div class="col-md-7">
                    <drop-file
                      ref="logo"
                      :placeholder="$t('gameSetting.logo')"
                      @file="file => (model.game_logo = file)"
                      :fileLink="model.game_logo"
                    />
                  </div>
                </div>
                <div class="row m-b-15">
                  <label class="col-form-label col-md-4">{{
                    $t('gameSetting.description')
                  }}</label>
                  <div class="col-md-7">
                    <textarea
                      v-model="model.description"
                      rows="3"
                      class="form-control"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import DropFile from './drop-file'

export default {
  name: 'gameSettingMainSetup',
  props: ['value', 'validate'],
  components: {
    DropFile
  },
  data() {
    return {
      errors: new Errors(),
      game_type_options: [],
      model: {}
    }
  },
  created() {
    this.fetchData()
    this.model = this.value
  },
  computed: {
    isEdit() {
      return !_.isEmpty(this.$store.state.administrator.gameSetting.edit_data)
    }
  },
  methods: {
    ...mapActions('administrator/gameSetting', ['gameType']),
    async fetchData() {
      this.loading = true
      await this.gameType()
        .then(response => {
          this.game_type_options = response.data.map(el => ({
            value: el.game_type_id,
            label: el.game_type
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
